module.exports = __webpack_public_path__ + "707e72990dfd021c1e995b8553ae1924.pdf";